import { get, head } from 'lodash-es'

import { getLinkUrlOfType, getLinkAllowedOfType } from '@/js/helper/links-helper.js'

import API_CONSTANTS from '@/js/helper/api-constants.js'
import GETTER_TYPES from '../getter-types'

export const getOrderGetters = MUTATION_TYPES => ({
  [GETTER_TYPES.ORDER_PROMISE]: state => get(state, MUTATION_TYPES.BASKET.promiseKey),
  [GETTER_TYPES.ORDER_LINKS]: state =>
    get(state, [[MUTATION_TYPES.ORDER.dataKey], ...API_CONSTANTS.AIMEOS.ORDER.PATHS.LINKS], []),
  [GETTER_TYPES.ORDER_PROCESS_URL]: (state, getters) =>
    getLinkUrlOfType(getters[GETTER_TYPES.ORDER_LINKS], API_CONSTANTS.LINK.PROCESS),
  [GETTER_TYPES.ORDER_PROCESS_PARAMS]: (state, getters) =>
    get(getters[GETTER_TYPES.ORDER_LINKS], [API_CONSTANTS.LINK.PROCESS, API_CONSTANTS.META], []),
  [GETTER_TYPES.ORDER_PROCESS_METHOD]: (state, getters) => {
    const allowed = getLinkAllowedOfType(
      getters[GETTER_TYPES.ORDER_LINKS],
      API_CONSTANTS.LINK.PROCESS,
    )
    return head(allowed) ? head(allowed) : 'GET'
  },
})
